module.exports = __webpack_public_path__ + "media/ets/tellem-banner-7d3d7d0e.jpeg";